import React, { useState, useEffect } from 'react';
import { 
  Sparkles,
  FileSpreadsheet,
  AlertCircle,
  Loader2,
  UserPlus,
  List,
  Trash2,
  X,
  Plus,
  ArrowRightLeft
} from 'lucide-react';
// Firebase fonksiyonları ve db importu
import { db } from '../firebase'; 
import {
  writeBatch,
  doc,
  collection,
  onSnapshot,
  query,
  where,
  deleteDoc,
  setDoc,
  getDocs
} from 'firebase/firestore';
const ClassManager = ({
  user,
  academicYear = '2026-2027',
  activeAcademicYear = '2026-2027'
}) => {

  const [className, setClassName] = useState('');
  const [rawList, setRawList] = useState('');
  const [savedClasses, setSavedClasses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [viewingClass, setViewingClass] = useState(null);
  const [showBulk, setShowBulk] = useState(false);
  const [bulkData, setBulkData] = useState("");
  const [bulkLoading, setBulkLoading] = useState(false);
  const [showAddStudent, setShowAddStudent] =
  useState(false);

const [newStudentNo, setNewStudentNo] =
  useState('');

const [newStudentName, setNewStudentName] =
  useState('');

const [movingStudent, setMovingStudent] =
  useState(null);

const [
  moveTargetClassId,
  setMoveTargetClassId
] = useState('');

const [
  studentActionLoading,
  setStudentActionLoading
] = useState(false);

  // Sınıfları dinle
  useEffect(() => {
  if (!user || !user.uid) return;

  const q = query(
    collection(db, "classes"),
    where("clinicianUid", "==", user.uid)
  );

  const unsubscribe = onSnapshot(q, (snapshot) => {

  const myClasses = snapshot.docs
    .map(document => ({
      ...document.data(),

      /*
       * Firestore'daki gerçek belge kimliği
       * her zaman son değer olarak kullanılmalı.
       *
       * document.data() içinde ayrıca "id"
       * alanı bulunsa bile gerçek document.id'nin
       * üzerine yazmasına izin vermiyoruz.
       */
      id: document.id
    }))
    .filter(cls => {
        const classYear = cls.academicYear || '2025-2026';
        return classYear === academicYear;
      });

    setSavedClasses(myClasses);
  });

  return () => unsubscribe();

}, [user, academicYear]);

// Açık sınıf penceresini canlı sınıf verisiyle senkron tut
useEffect(() => {

  if (!viewingClass) {
    return;
  }


  const refreshedClass =
    savedClasses.find(
      cls =>
        String(cls.id) ===
        String(viewingClass.id)
    );


  if (!refreshedClass) {
    setViewingClass(null);
    return;
  }


  setViewingClass(
    refreshedClass
  );

}, [
  savedClasses,
  viewingClass?.id
]);

  // --- 1. YENİ EFSANE MOTOR: AKILLI E-OKUL SÜZGECİ ---
  const handleBulkImport = async () => {
  if (academicYear !== activeAcademicYear) {
  return alert(
    `${academicYear} geçmiş dönemidir.\n\nGeçmiş dönem sınıf listeleri değiştirilemez.`
  );
}
    if (!bulkData.trim()) return alert("Lütfen e-Okul'dan kopyaladığınız veriyi yapıştırın.");
    setBulkLoading(true);

    try {
      const batch = writeBatch(db); 
      const rows = bulkData.split(/\r?\n/); 
      
      let count = 0;
      let currentClass = "BELİRSİZ"; // E-Okul'dan bulamazsa buna atar
      const groups = {}; // Sınıfları otomatik gruplamak için

      rows.forEach(row => {
        // 1. ADIM: Satırı tertemiz yap (Virgülleri, Tab'ları boşluk yap, .0 ları sil)
        let cleaned = row.replace(/,/g, ' ').replace(/\t/g, ' ').replace(/\.0\b/g, '').trim();
        cleaned = cleaned.replace(/\s+/g, ' '); // Birden fazla boşluğu teke indir

        if (!cleaned) return;

        // 2. ADIM: Sınıf Adını Otomatik Tespit Et (Örn: "12. Sınıf / Z Şubesi")
        const classMatch = cleaned.match(/(\d+)\.?\s*Sınıf\s*\/\s*([A-ZĞÜŞİÖÇ]+)\s*Şubesi/i);
        if (classMatch) {
            currentClass = `${classMatch[1]}/${classMatch[2].toUpperCase()}`;
            return; // Bu satır sadece sınıf adını taşıyor, öğrenci değil, atla!
        }

        // 3. ADIM: E-Okul'un çöp satırlarını görmezden gel
        if (cleaned.match(/T\.C\.|VALİLİĞİ|Müdürlüğü|Sınıf Listesi|Sınıf Öğretmeni|Kız Öğrenci|Erkek Öğrenci|Toplam Öğrenci|S\.No|Pansiyon Durum/i)) {
            return;
        }

        const parts = cleaned.split(' ');
        if (parts.length < 2) return;

        let studentNo = null;
        let nameParts = [];

        // 4. ADIM: Öğrenciyi Yakala
        // E-Okul Formatı: "SıraNo OkulNo Adı Soyadı Cinsiyet" (Örn: 1 10 FURKAN ARPACI Erkek)
        if (!isNaN(parts[0]) && !isNaN(parts[1])) {
            studentNo = parts[1]; // İkinci numara asıl okul numarasıdır
            
            // Sondaki "Erkek" veya "Kız" yazısını isimden çıkar
            let endIdx = parts.length;
            if (['Erkek', 'Kız', 'ERKEK', 'KIZ'].includes(parts[parts.length - 1])) {
                endIdx = parts.length - 1;
            }
            nameParts = parts.slice(2, endIdx);
        } 
        // Normal (Düz Liste) Formatı: "OkulNo Adı Soyadı" (Örn: 64 ALPEREN SAKARYA)
        else if (!isNaN(parts[0])) {
            studentNo = parts[0];
            let endIdx = parts.length;
            
            // Eğer en sona elle "12/P" gibi sınıf yazmışlarsa onu yakala
            if (parts[parts.length - 1].includes('/')) {
                currentClass = parts[parts.length - 1].toUpperCase();
                endIdx = parts.length - 1;
            }
            nameParts = parts.slice(1, endIdx);
        } else {
            return; // Başında numara yoksa öğrenci değildir, çöpe at.
        }

       // 5. ADIM: Yakalanan Öğrenciyi Hafızaya Al
if (studentNo && nameParts.length > 0) {

    const studentObj = {
        no: studentNo,
        name: nameParts.join(' ').toUpperCase()
    };

    // Öğrenciyi students havuzuna ekle
    const docRef = doc(collection(db, "students"));

    batch.set(docRef, {
        number: studentObj.no,
        name: studentObj.name,
        class: currentClass,
        clinicianCode: user.refCode,
        clinicianUid: user.uid,
        academicYear: academicYear,
        createdAt: new Date().toISOString()
    });

    // Aynı zamanda sınıf grubuna ekle
    if (!groups[currentClass]) {
        groups[currentClass] = [];
    }

    groups[currentClass].push(studentObj);

    count++;
}

});

// 6. ADIM: Gruplanan sınıfları Firebase'e yaz
for (const [clsName, studentsList] of Object.entries(groups)) {

    const safeClassName = clsName
        .replace(/\s+/g, '')
        .replace(/\//g, '-')
        .toUpperCase();

    const classDocId =
        `${user.refCode}_${academicYear}_${safeClassName}`;

    const classDocRef = doc(
        db,
        "classes",
        classDocId
    );

    batch.set(classDocRef, {
        id: classDocId,
        clinicianCode: user.refCode,
        clinicianUid: user.uid,
        academicYear: academicYear,
        name: clsName,
        students: studentsList,
        timestamp: new Date().toISOString()
    });
}

// Her Şeyi Tek Seferde Veritabanına Yaz!
      if (count > 0) {
        await batch.commit();
        alert(`🎉 İŞLEM BAŞARILI!\n\nYapay Zeka Süzgeci E-Okul verisini taradı ve içinden çöpleri ayıkladı.\n\n✅ Toplam ${count} öğrenci bulundu.\n✅ Sınıf listeleri otomatik oluşturuldu.`);
        setBulkData("");
        setShowBulk(false);
      } else {
        alert("⚠️ Kaydedilecek öğrenci bulunamadı. Lütfen veriyi kontrol edin.");
      }

    } catch (error) {
      console.error(error);
      alert("Hata: " + error.message);
    } finally {
      setBulkLoading(false);
    }
  };

  const handleSaveList =
  async () => {

    if (
      academicYear !==
      activeAcademicYear
    ) {
      return alert(
        `${academicYear} geçmiş dönemidir.\n\n` +
        `Geçmiş dönem sınıf listeleri değiştirilemez.`
      );
    }


    if (
      !className.trim() ||
      !rawList.trim()
    ) {
      return alert(
        "Sınıf adı ve liste giriniz."
      );
    }


    setLoading(true);


    try {

      const students =
        rawList
          .split('\n')
          .map(
            line => {

              const trimmed =
                line.trim();


              if (!trimmed) {
                return null;
              }


              const match =
                trimmed.match(
                  /^(\d+)\s+(.+)$/
                );


              if (!match) {
                return null;
              }


              return {
                no:
                  String(
                    match[1]
                  ).trim(),

                name:
                  match[2]
                    .trim()
                    .toUpperCase()
              };
            }
          )
          .filter(Boolean);


      if (
        students.length === 0
      ) {
        alert(
          "Format hatası."
        );

        return;
      }


      const normalizedClassName =
        className
          .trim()
          .toUpperCase();


      // ==========================================================
      // AYNI SINIF VAR MI?
      // ==========================================================

      const existingClass =
        savedClasses.find(
          cls =>
            String(
              cls?.name ?? ''
            )
              .trim()
              .toUpperCase() ===
            normalizedClassName
        ) ||
        null;


      const existingStudents =
        Array.isArray(
          existingClass?.students
        )
          ? existingClass.students
          : [];


      // ==========================================================
      // ÖĞRENCİLERİ NUMARAYA GÖRE BİRLEŞTİR
      // ==========================================================
      //
      // Aynı numara varsa ikinci öğrenci oluşturulmaz.
      // Yeni girilen ad-soyad değeri güncel kabul edilir.
      // ==========================================================

      const studentMap =
        new Map();


      existingStudents.forEach(
        student => {

          const no =
            String(
              student?.no ?? ''
            ).trim();


          if (!no) {
            return;
          }


          studentMap.set(
            no,
            {
              no,
              name:
                String(
                  student?.name ?? ''
                ).trim()
            }
          );
        }
      );


      students.forEach(
        student => {

          studentMap.set(
            student.no,
            student
          );
        }
      );


      const mergedStudents =
        Array.from(
          studentMap.values()
        )
          .sort(
            (a, b) =>
              String(a.no)
                .localeCompare(
                  String(b.no),
                  undefined,
                  {
                    numeric: true
                  }
                )
          );


      const safeClassName =
        normalizedClassName
          .replace(/\s+/g, '')
          .replace(/\//g, '-');


      const generatedClassDocId =
        `${user.refCode}_${academicYear}_${safeClassName}`;


      // Mevcut sınıf varsa gerçek Firestore document.id kullanılır.
      // Yoksa deterministik yeni belge kimliği oluşturulur.
      const targetClassDocId =
        existingClass?.id ||
        generatedClassDocId;


      const classDocRef =
        doc(
          db,
          "classes",
          String(
            targetClassDocId
          )
        );


      await setDoc(
        classDocRef,
        {
          id:
            String(
              targetClassDocId
            ),

          clinicianCode:
            user.refCode,

          clinicianUid:
            user.uid,

          academicYear:
            academicYear,

          name:
            normalizedClassName,

          students:
            mergedStudents,

          timestamp:
            new Date()
              .toISOString()
        },
        {
          merge: true
        }
      );


      setClassName('');
      setRawList('');


      if (existingClass) {

        const addedCount =
          mergedStudents.length -
          existingStudents.length;


        alert(
          `✅ ${normalizedClassName} güncellendi.\n\n` +
          `Toplam öğrenci: ${mergedStudents.length}\n` +
          `Yeni öğrenci: ${Math.max(0, addedCount)}`
        );

      } else {

        alert(
          `✅ ${normalizedClassName} oluşturuldu.\n\n` +
          `${mergedStudents.length} öğrenci kaydedildi.`
        );
      }

    } catch (error) {

      console.error(
        "Manuel sınıf kayıt hatası:",
        error
      );


      alert(
        "Sınıf kaydedilirken bir hata oluştu.\n\n" +
        (
          error?.message ||
          "Bilinmeyen hata"
        )
      );

    } finally {

      setLoading(false);
    }
  };


// ============================================================
// SINIF İÇİ ÖĞRENCİ YÖNETİMİ
// ============================================================

const normalizeStudentNo =
  value =>
    String(
      value ?? ''
    ).trim();


const sortStudents =
  students =>
    [...students].sort(
      (a, b) =>
        String(a?.no ?? '')
          .localeCompare(
            String(b?.no ?? ''),
            undefined,
            {
              numeric: true
            }
          )
    );


// students koleksiyonundaki aynı öğrenciye ait
// aktif eğitim yılı kayıtlarını bul.
// Eski toplu yüklemelerden mükerrer master kayıt çıkmışsa
// hepsi birlikte güncellenir / silinir.
const getStudentMasterDocs =
  async studentNo => {

    const normalizedNo =
      normalizeStudentNo(
        studentNo
      );


    const studentsQuery =
      query(
        collection(
          db,
          "students"
        ),

        where(
          "clinicianUid",
          "==",
          user.uid
        )
      );


    const snapshot =
      await getDocs(
        studentsQuery
      );


    return snapshot.docs.filter(
      studentDoc => {

        const data =
          studentDoc.data();


        const studentYear =
          data.academicYear ||
          '2025-2026';


        const storedNo =
          normalizeStudentNo(
            data.number ??
            data.no
          );


        return (
          studentYear ===
            academicYear &&
          storedNo ===
            normalizedNo
        );
      }
    );
  };


// ============================================================
// + ÖĞRENCİ EKLE
// ============================================================

const handleAddStudentToClass =
  async () => {

    if (
      academicYear !==
      activeAcademicYear
    ) {
      return alert(
        `${academicYear} geçmiş dönemidir.\n\n` +
        `Geçmiş dönem sınıf listeleri değiştirilemez.`
      );
    }


    if (!viewingClass) {
      return;
    }


    const normalizedNo =
      normalizeStudentNo(
        newStudentNo
      );


    const normalizedName =
      String(
        newStudentName ?? ''
      )
        .trim()
        .toUpperCase();


    if (
      !normalizedNo ||
      !normalizedName
    ) {
      return alert(
        "Öğrenci numarası ve adı soyadı girilmelidir."
      );
    }


    if (
      !/^\d+$/.test(
        normalizedNo
      )
    ) {
      return alert(
        "Öğrenci numarası yalnızca rakamlardan oluşmalıdır."
      );
    }


    // Aynı okul numarası başka bir aktif sınıfta mı?
    const existingOwner =
      savedClasses.find(
        cls =>
          Array.isArray(
            cls?.students
          ) &&
          cls.students.some(
            student =>
              normalizeStudentNo(
                student?.no
              ) ===
              normalizedNo
          )
      );


    if (existingOwner) {

      if (
        String(existingOwner.id) ===
        String(viewingClass.id)
      ) {
        return alert(
          `${normalizedNo} numaralı öğrenci zaten ${viewingClass.name} sınıfında.`
        );
      }


      return alert(
        `${normalizedNo} numaralı öğrenci zaten ${existingOwner.name} sınıfında kayıtlı.\n\n` +
        `Öğrenciyi başka bir sınıfa geçirmek için "Taşı" işlemini kullanın.`
      );
    }


    setStudentActionLoading(
      true
    );


    try {

      const studentObj = {
        no:
          normalizedNo,

        name:
          normalizedName
      };


      const nextStudents =
        sortStudents([
          ...(
            Array.isArray(
              viewingClass.students
            )
              ? viewingClass.students
              : []
          ),

          studentObj
        ]);


      const masterDocs =
        await getStudentMasterDocs(
          normalizedNo
        );


      const batch =
        writeBatch(db);


      // Sınıf belgesini güncelle
      batch.set(
        doc(
          db,
          "classes",
          String(
            viewingClass.id
          )
        ),
        {
          students:
            nextStudents,

          timestamp:
            new Date()
              .toISOString()
        },
        {
          merge: true
        }
      );


      // Öğrenci ana kaydı varsa güncelle
      if (
        masterDocs.length > 0
      ) {

        masterDocs.forEach(
          studentDoc => {

            batch.set(
              studentDoc.ref,
              {
                number:
                  normalizedNo,

                name:
                  normalizedName,

                class:
                  viewingClass.name,

                clinicianCode:
                  user.refCode,

                clinicianUid:
                  user.uid,

                academicYear:
                  academicYear,

                updatedAt:
                  new Date()
                    .toISOString()
              },
              {
                merge: true
              }
            );
          }
        );

      } else {

        // Yoksa yeni ana öğrenci kaydı oluştur
        const studentDocRef =
          doc(
            collection(
              db,
              "students"
            )
          );


        batch.set(
          studentDocRef,
          {
            number:
              normalizedNo,

            name:
              normalizedName,

            class:
              viewingClass.name,

            clinicianCode:
              user.refCode,

            clinicianUid:
              user.uid,

            academicYear:
              academicYear,

            createdAt:
              new Date()
                .toISOString()
          }
        );
      }


      await batch.commit();


      setViewingClass(
        prev =>
          prev
            ? {
                ...prev,
                students:
                  nextStudents
              }
            : prev
      );


      setNewStudentNo('');
      setNewStudentName('');
      setShowAddStudent(false);


      alert(
        `✅ ${normalizedName}, ${viewingClass.name} sınıfına eklendi.`
      );

    } catch (error) {

      console.error(
        "Öğrenci ekleme hatası:",
        error
      );


      alert(
        "Öğrenci eklenirken bir hata oluştu.\n\n" +
        (
          error?.message ||
          "Bilinmeyen hata"
        )
      );

    } finally {

      setStudentActionLoading(
        false
      );
    }
  };


// ============================================================
// ÖĞRENCİ TAŞI
// ============================================================

const handleMoveStudent =
  async student => {

    if (
      academicYear !==
      activeAcademicYear
    ) {
      return alert(
        `${academicYear} geçmiş dönemidir.\n\n` +
        `Geçmiş dönem sınıf listeleri değiştirilemez.`
      );
    }


    if (
      !viewingClass ||
      !student
    ) {
      return;
    }


    if (!moveTargetClassId) {
      return alert(
        "Öğrencinin taşınacağı sınıfı seçin."
      );
    }


    const targetClass =
      savedClasses.find(
        cls =>
          String(cls.id) ===
          String(
            moveTargetClassId
          )
      );


    if (!targetClass) {
      return alert(
        "Hedef sınıf bulunamadı."
      );
    }


    if (
      String(targetClass.id) ===
      String(viewingClass.id)
    ) {
      return alert(
        "Öğrenci zaten bu sınıfta."
      );
    }


    const normalizedNo =
      normalizeStudentNo(
        student.no
      );


    const targetHasStudent =
      Array.isArray(
        targetClass.students
      ) &&
      targetClass.students.some(
        item =>
          normalizeStudentNo(
            item?.no
          ) ===
          normalizedNo
      );


    if (targetHasStudent) {
      return alert(
        `${normalizedNo} numaralı öğrenci hedef sınıfta zaten kayıtlı.`
      );
    }


    // Başka bir üçüncü sınıfta da aynı numara varsa
    // veri çoğaltmayı durdur.
    const unexpectedOwner =
      savedClasses.find(
        cls =>
          String(cls.id) !==
            String(viewingClass.id) &&
          String(cls.id) !==
            String(targetClass.id) &&
          Array.isArray(
            cls.students
          ) &&
          cls.students.some(
            item =>
              normalizeStudentNo(
                item?.no
              ) ===
              normalizedNo
          )
      );


    if (unexpectedOwner) {
      return alert(
        `${normalizedNo} numaralı öğrenci ayrıca ${unexpectedOwner.name} sınıfında da görünüyor.\n\n` +
        `Önce bu mükerrer kaydı kontrol edin.`
      );
    }


    const confirmed =
      window.confirm(
        `${student.name}\n\n` +
        `${viewingClass.name} → ${targetClass.name}\n\n` +
        `öğrencisi taşınsın mı?`
      );


    if (!confirmed) {
      return;
    }


    setStudentActionLoading(
      true
    );


    try {

      const sourceStudents =
        sortStudents(
          (
            Array.isArray(
              viewingClass.students
            )
              ? viewingClass.students
              : []
          ).filter(
            item =>
              normalizeStudentNo(
                item?.no
              ) !==
              normalizedNo
          )
        );


      const targetStudents =
        sortStudents([
          ...(
            Array.isArray(
              targetClass.students
            )
              ? targetClass.students
              : []
          ),

          {
            no:
              normalizedNo,

            name:
              String(
                student.name ?? ''
              )
                .trim()
                .toUpperCase()
          }
        ]);


      const masterDocs =
        await getStudentMasterDocs(
          normalizedNo
        );


      const batch =
        writeBatch(db);


      // Kaynak sınıftan çıkar
      batch.set(
        doc(
          db,
          "classes",
          String(
            viewingClass.id
          )
        ),
        {
          students:
            sourceStudents,

          timestamp:
            new Date()
              .toISOString()
        },
        {
          merge: true
        }
      );


      // Hedef sınıfa ekle
      batch.set(
        doc(
          db,
          "classes",
          String(
            targetClass.id
          )
        ),
        {
          students:
            targetStudents,

          timestamp:
            new Date()
              .toISOString()
        },
        {
          merge: true
        }
      );


      // Ana öğrenci kaydındaki sınıfı da güncelle
      if (
        masterDocs.length > 0
      ) {

        masterDocs.forEach(
          studentDoc => {

            batch.set(
              studentDoc.ref,
              {
                number:
                  normalizedNo,

                name:
                  String(
                    student.name ?? ''
                  )
                    .trim()
                    .toUpperCase(),

                class:
                  targetClass.name,

                academicYear:
                  academicYear,

                updatedAt:
                  new Date()
                    .toISOString()
              },
              {
                merge: true
              }
            );
          }
        );

      } else {

        const studentDocRef =
          doc(
            collection(
              db,
              "students"
            )
          );


        batch.set(
          studentDocRef,
          {
            number:
              normalizedNo,

            name:
              String(
                student.name ?? ''
              )
                .trim()
                .toUpperCase(),

            class:
              targetClass.name,

            clinicianCode:
              user.refCode,

            clinicianUid:
              user.uid,

            academicYear:
              academicYear,

            createdAt:
              new Date()
                .toISOString()
          }
        );
      }


      // İki sınıf + öğrenci kaydı
      // tek atomik commit ile değişir.
      await batch.commit();


      setViewingClass(
        prev =>
          prev
            ? {
                ...prev,
                students:
                  sourceStudents
              }
            : prev
      );


      setMovingStudent(null);
      setMoveTargetClassId('');


      alert(
        `✅ ${student.name}\n\n` +
        `${viewingClass.name} sınıfından ${targetClass.name} sınıfına taşındı.`
      );

    } catch (error) {

      console.error(
        "Öğrenci taşıma hatası:",
        error
      );


      alert(
        "Öğrenci taşınırken bir hata oluştu.\n\n" +
        (
          error?.message ||
          "Bilinmeyen hata"
        )
      );

    } finally {

      setStudentActionLoading(
        false
      );
    }
  };


// ============================================================
// TEK ÖĞRENCİ SİL
// ============================================================

const handleDeleteStudent =
  async student => {

    if (
      academicYear !==
      activeAcademicYear
    ) {
      return alert(
        `${academicYear} geçmiş dönemidir.\n\n` +
        `Geçmiş dönem sınıf listeleri değiştirilemez.`
      );
    }


    if (
      !viewingClass ||
      !student
    ) {
      return;
    }


    const normalizedNo =
      normalizeStudentNo(
        student.no
      );


    const confirmed =
      window.confirm(
        `${student.name} (${normalizedNo}) aktif sınıf listesinden çıkarılacak.\n\n` +
        `Test, form ve geçmiş PDR kayıtları SİLİNMEYECEKTİR. ` +
        `Varsa geçmiş öğrenci verileri Öğrenci Dosyaları arşivinde korunacaktır.\n\n` +
        `Devam edilsin mi?`
      );


    if (!confirmed) {
      return;
    }


    setStudentActionLoading(
      true
    );


    try {

      const nextStudents =
        sortStudents(
          (
            Array.isArray(
              viewingClass.students
            )
              ? viewingClass.students
              : []
          ).filter(
            item =>
              normalizeStudentNo(
                item?.no
              ) !==
              normalizedNo
          )
        );


      const masterDocs =
        await getStudentMasterDocs(
          normalizedNo
        );


      const batch =
        writeBatch(db);


      // Yalnız aktif sınıf listesinden çıkar.
      batch.set(
        doc(
          db,
          "classes",
          String(
            viewingClass.id
          )
        ),
        {
          students:
            nextStudents,

          timestamp:
            new Date()
              .toISOString()
        },
        {
          merge: true
        }
      );


      // Aktif öğrenci ana kayıtlarını kaldır.
      // submissions / counselorNotes gibi tarihsel kayıtlar
      // burada silinmez.
      masterDocs.forEach(
        studentDoc => {
          batch.delete(
            studentDoc.ref
          );
        }
      );


      await batch.commit();


      setViewingClass(
        prev =>
          prev
            ? {
                ...prev,
                students:
                  nextStudents
              }
            : prev
      );


      if (
        normalizeStudentNo(
          movingStudent?.no
        ) ===
        normalizedNo
      ) {
        setMovingStudent(null);
        setMoveTargetClassId('');
      }


      alert(
        `✅ ${student.name} aktif sınıf listesinden çıkarıldı.`
      );

    } catch (error) {

      console.error(
        "Öğrenci silme hatası:",
        error
      );


      alert(
        "Öğrenci silinirken bir hata oluştu.\n\n" +
        (
          error?.message ||
          "Bilinmeyen hata"
        )
      );

    } finally {

      setStudentActionLoading(
        false
      );
    }
  };

 const handleDeleteClass = async (id) => {

  if (academicYear !== activeAcademicYear) {
    return alert(
      `${academicYear} geçmiş dönemidir.\n\nGeçmiş dönem sınıf listeleri silinemez.`
    );
  }


  const confirmed =
    window.confirm(
      "Silmek istediğinize emin misiniz?"
    );


  if (!confirmed) {
    return;
  }


  try {

    /*
     * savedClasses içindeki id artık doğrudan
     * Firestore document.id değeridir.
     */
    const classDocRef =
      doc(
        db,
        "classes",
        String(id)
      );


    await deleteDoc(
      classDocRef
    );


    if (
      viewingClass &&
      viewingClass.id === id
    ) {
      setViewingClass(null);
    }

  } catch (error) {

    console.error(
      "Sınıf silme hatası:",
      error
    );

    alert(
      "Sınıf silinemedi.\n\n" +
      (error?.message ||
        "Bilinmeyen bir hata oluştu.")
    );
  }
};

  return (
    <div className="space-y-8 no-print">
      <div className="bg-slate-900 text-white p-8 rounded-[2.5rem] shadow-2xl flex flex-col md:flex-row justify-between items-center gap-6">
        <div>
          <h2 className="text-3xl font-black tracking-tight">Öğrenci & Sınıf Yönetimi</h2>
          <p className="text-slate-400 mt-2">
  Okul listesini hiçbir düzeltme yapmadan doğrudan yükleyin.
  <span className="ml-2 text-blue-300 font-bold">
    • {academicYear}
  </span>
</p>

{academicYear !== activeAcademicYear && (
  <div className="bg-amber-50 border border-amber-200 text-amber-800 px-5 py-4 rounded-2xl font-bold text-sm">
    📚 {academicYear} geçmiş eğitim öğretim yılı görüntüleniyor.
    Sınıf listeleri yalnızca görüntülenebilir.
  </div>
)}
        </div>
      </div>

      {/* YENİ UI: AKILLI E-OKUL IMPORT KISMI */}
      <div className="bg-white p-1 rounded-2xl border-2 border-green-500 shadow-sm overflow-hidden relative">
         <div className="absolute top-0 right-0 bg-green-500 text-white text-[10px] font-black px-3 py-1 rounded-bl-xl uppercase tracking-widest flex items-center shadow-sm">
             <Sparkles className="h-3 w-3 mr-1"/> Yapay Zeka Süzgeci Aktif
         </div>
         <button onClick={() => setShowBulk(!showBulk)} className={`w-full p-6 flex items-center justify-between transition ${showBulk ? 'bg-green-50 text-green-800' : 'bg-white hover:bg-green-50 text-slate-700'}`}>
            <div className="flex items-center gap-4">
               <div className={`h-12 w-12 rounded-xl flex items-center justify-center ${showBulk ? 'bg-green-600 text-white' : 'bg-green-100 text-green-600'}`}>
                   <FileSpreadsheet className="h-6 w-6"/>
               </div>
               <div className="text-left">
                   <h3 className="font-bold text-lg">E-Okul'dan Kopyala ve Yapıştır</h3>
                   <p className="text-xs opacity-70">Listeyi düzenlemenize gerek yok! Çöpleri biz temizleriz.</p>
               </div>
            </div>
            <div className="text-sm font-bold underline decoration-2 underline-offset-4 text-green-600">{showBulk ? "Kapat" : "Listeyi Aç"}</div>
         </button>

         {showBulk && (
            <div className="p-6 pt-0 bg-green-50 animate-in slide-in-from-top-4">
               <div className="bg-white p-4 rounded-xl border border-green-200 shadow-sm mb-4">
                  <h4 className="font-bold text-green-800 text-sm mb-2 flex items-center"><AlertCircle className="h-4 w-4 mr-2"/> NASIL KULLANILIR?</h4>
                  <p className="text-xs text-slate-600 leading-relaxed">
                     E-Okul'dan aldığınız listeyi (sayfa başlıkları, boşluklar, müdür imzaları vs. dahil) **hiçbir yeri silmeden** kopyalayıp aşağıdaki kutuya yapıştırın.<br/>
                     Akıllı süzgeç sınıf adını ve numaraları kendi bulup listeyi tertemiz çıkaracaktır.
                  </p>
               </div>
               <textarea 
                  value={bulkData} 
                  onChange={(e) => setBulkData(e.target.value)} 
                  placeholder="E-okul'dan kopyaladığınız listeyi buraya yapıştırın (CTRL+V)..." 
                  className="w-full h-64 px-4 py-3 bg-white border border-green-300 rounded-xl text-xs font-mono focus:ring-2 focus:ring-green-500 outline-none resize-none mb-4 shadow-inner"
               />
               <button onClick={handleBulkImport} disabled={bulkLoading} className="w-full py-4 bg-green-600 hover:bg-green-700 text-white rounded-xl font-black text-lg transition flex items-center justify-center shadow-lg shadow-green-200">
                   {bulkLoading ? <Loader2 className="animate-spin h-6 w-6"/> : "Listeyi Tara ve Sınıfları Oluştur"}
               </button>
            </div>
         )}
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm h-fit">
          <h3 className="font-bold text-slate-800 mb-4 flex items-center"><UserPlus className="h-5 w-5 mr-2 text-blue-600"/> Manuel Sınıf Oluştur</h3>
          <p className="text-xs text-slate-400 mb-4">Tek bir sınıfı elle girmek isterseniz kullanın.</p>
          <div className="space-y-4">
            <div><label className="text-xs font-bold text-slate-400 ml-1">SINIF ADI</label><input type="text" value={className} onChange={(e) => setClassName(e.target.value)} placeholder="Örn: 12/P" className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl font-bold focus:border-blue-500 outline-none"/></div>
            <div><label className="text-xs font-bold text-slate-400 ml-1">ÖĞRENCİ LİSTESİ</label><textarea value={rawList} onChange={(e) => setRawList(e.target.value)} placeholder={"64 ALPEREN SAKARYA\n66 ABDULLAH YİĞİT..."} className="w-full h-48 px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm font-mono focus:border-blue-500 outline-none resize-none"/><p className="text-[10px] text-slate-400 mt-1">*Format: "Numara Ad Soyad"</p></div>
            <button onClick={handleSaveList} disabled={loading} className="w-full py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-bold transition flex items-center justify-center">{loading ? <Loader2 className="animate-spin h-5 w-5"/> : "Grubu Kaydet"}</button>
          </div>
        </div>

        <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm overflow-y-auto max-h-[600px] custom-scrollbar">
          <h3 className="font-bold text-slate-800 mb-4 flex items-center"><List className="h-5 w-5 mr-2 text-indigo-600"/> Tanımlı Sınıflar</h3>
          {savedClasses.length === 0 ? (<div className="text-center text-slate-400 py-10"><p>Henüz sınıf grubu oluşturulmamış.<br/><span className="text-green-600 text-xs font-bold">Yukarıdaki Akıllı Yükleyiciyi deneyin!</span></p></div>) : (
            <div className="space-y-3">
              {savedClasses.map(cls => (
                <div key={cls.id} onClick={() => setViewingClass(cls)} className="p-4 bg-slate-50 rounded-xl border border-slate-100 flex justify-between items-center group cursor-pointer hover:border-blue-400 hover:shadow-md transition select-none">
                  <div className="flex items-center gap-3">
                    <div className="h-10 w-10 bg-white rounded-full flex items-center justify-center border border-slate-200 text-slate-500 font-bold group-hover:text-blue-600 group-hover:border-blue-200 transition">{cls.name.substring(0,3)}</div>
                    <div><h4 className="font-black text-lg text-slate-800 group-hover:text-blue-700 transition">{cls.name}</h4><span className="text-xs text-slate-500 font-medium">{cls.students.length} Öğrenci</span></div>
                  </div>
                  <button onClick={(e) => { e.stopPropagation(); handleDeleteClass(cls.id); }} className="p-2 bg-white text-slate-300 hover:text-red-600 hover:bg-red-50 rounded-lg border border-slate-200 transition"><Trash2 className="h-4 w-4"/></button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      
     {/* SINIF YÖNETİM MODALI */}
{viewingClass && (

  <div
    className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[80] flex items-center justify-center p-4"
    onClick={() => {
      setViewingClass(null);
      setShowAddStudent(false);
      setMovingStudent(null);
      setMoveTargetClassId('');
    }}
  >

    <div
      className="bg-white w-full max-w-2xl rounded-3xl shadow-2xl overflow-hidden flex flex-col max-h-[88vh] animate-in fade-in zoom-in-95 duration-200"
      onClick={
        e =>
          e.stopPropagation()
      }
    >

      {/* HEADER */}
      <div className="bg-slate-50 p-6 border-b border-slate-200 flex justify-between items-center shrink-0">

        <div>
          <h3 className="text-2xl font-black text-slate-800">
            {viewingClass.name} Listesi
          </h3>

          <p className="text-sm text-slate-500">
            {
              Array.isArray(
                viewingClass.students
              )
                ? viewingClass.students.length
                : 0
            } Öğrenci
          </p>
        </div>


        <button
          onClick={() => {
            setViewingClass(null);
            setShowAddStudent(false);
            setMovingStudent(null);
            setMoveTargetClassId('');
          }}
          className="p-2 hover:bg-slate-200 rounded-full transition"
        >
          <X className="h-6 w-6 text-slate-400"/>
        </button>

      </div>


      {/* ÖĞRENCİ EKLE PANELİ */}
      {
        academicYear ===
          activeAcademicYear &&
        showAddStudent && (

          <div className="p-5 bg-blue-50 border-b border-blue-100">

            <div className="flex items-center gap-2 mb-4">

              <UserPlus className="h-5 w-5 text-blue-600"/>

              <h4 className="font-black text-blue-900">
                {viewingClass.name} Sınıfına Öğrenci Ekle
              </h4>

            </div>


            <div className="grid grid-cols-1 md:grid-cols-[120px_1fr_auto] gap-3">

              <input
                type="text"
                inputMode="numeric"
                value={newStudentNo}
                onChange={
                  e =>
                    setNewStudentNo(
                      e.target.value
                    )
                }
                placeholder="Okul No"
                className="px-4 py-3 bg-white border border-blue-200 rounded-xl text-sm font-bold outline-none focus:ring-2 focus:ring-blue-500"
              />


              <input
                type="text"
                value={newStudentName}
                onChange={
                  e =>
                    setNewStudentName(
                      e.target.value
                    )
                }
                placeholder="Ad Soyad"
                className="px-4 py-3 bg-white border border-blue-200 rounded-xl text-sm font-bold outline-none focus:ring-2 focus:ring-blue-500"
              />


              <button
                onClick={
                  handleAddStudentToClass
                }
                disabled={
                  studentActionLoading
                }
                className="px-5 py-3 bg-blue-600 hover:bg-blue-700 disabled:bg-blue-300 text-white rounded-xl font-black text-sm transition flex items-center justify-center"
              >

                {
                  studentActionLoading
                    ? (
                      <Loader2 className="h-4 w-4 animate-spin"/>
                    )
                    : "Ekle"
                }

              </button>

            </div>

          </div>
        )
      }


      {/* ÖĞRENCİ LİSTESİ */}
      <div className="flex-1 overflow-y-auto p-6 custom-scrollbar">

        <table className="w-full text-sm">

          <thead className="bg-slate-100 text-slate-500 font-bold uppercase text-xs sticky top-0 z-10">

            <tr>

              <th className="p-3 text-left rounded-l-lg">
                No
              </th>

              <th className="p-3 text-left">
                Adı Soyadı
              </th>

              <th className="p-3 text-right rounded-r-lg">
                İşlem
              </th>

            </tr>

          </thead>


          <tbody className="divide-y divide-slate-100">

            {
              Array.isArray(
                viewingClass.students
              ) &&
              viewingClass.students.length >
                0
                ? (

                  [...viewingClass.students]
                    .sort(
                      (a, b) =>
                        String(a.no)
                          .localeCompare(
                            String(b.no),
                            undefined,
                            {
                              numeric: true
                            }
                          )
                    )
                    .map(
                      stu => (

                        <React.Fragment
                          key={
                            String(
                              stu.no
                            )
                          }
                        >

                          <tr className="hover:bg-slate-50 transition">

                            <td className="p-3 font-black text-blue-600">
                              {stu.no}
                            </td>


                            <td className="p-3 font-medium text-slate-700">
                              {stu.name}
                            </td>


                            <td className="p-3">

                              <div className="flex items-center justify-end gap-2">

                                {
                                  academicYear ===
                                    activeAcademicYear && (
                                    <>

                                      <button
                                        onClick={() => {

                                          const isSame =
                                            normalizeStudentNo(
                                              movingStudent?.no
                                            ) ===
                                            normalizeStudentNo(
                                              stu.no
                                            );


                                          setMovingStudent(
                                            isSame
                                              ? null
                                              : stu
                                          );

                                          setMoveTargetClassId('');

                                        }}
                                        disabled={
                                          studentActionLoading
                                        }
                                        className="px-3 py-1.5 bg-indigo-50 hover:bg-indigo-100 text-indigo-700 rounded-lg font-bold text-xs transition flex items-center gap-1"
                                      >

                                        <ArrowRightLeft className="h-3.5 w-3.5"/>

                                        Taşı

                                      </button>


                                      <button
                                        onClick={
                                          () =>
                                            handleDeleteStudent(
                                              stu
                                            )
                                        }
                                        disabled={
                                          studentActionLoading
                                        }
                                        className="p-2 bg-red-50 hover:bg-red-100 text-red-500 hover:text-red-700 rounded-lg transition"
                                        title="Öğrenciyi sınıf listesinden çıkar"
                                      >

                                        <Trash2 className="h-4 w-4"/>

                                      </button>

                                    </>
                                  )
                                }

                              </div>

                            </td>

                          </tr>


                          {/* TAŞIMA PANELİ */}
                          {
                            movingStudent &&
                            normalizeStudentNo(
                              movingStudent.no
                            ) ===
                            normalizeStudentNo(
                              stu.no
                            ) && (

                              <tr>

                                <td
                                  colSpan="3"
                                  className="p-3 bg-indigo-50"
                                >

                                  <div className="flex flex-col md:flex-row items-stretch md:items-center gap-3">

                                    <div className="text-xs font-bold text-indigo-700 md:mr-auto">
                                      {stu.name} öğrencisini taşı:
                                    </div>


                                    <select
                                      value={
                                        moveTargetClassId
                                      }
                                      onChange={
                                        e =>
                                          setMoveTargetClassId(
                                            e.target.value
                                          )
                                      }
                                      className="px-3 py-2.5 bg-white border border-indigo-200 rounded-xl text-sm font-bold text-slate-700 outline-none focus:ring-2 focus:ring-indigo-500"
                                    >

                                      <option value="">
                                        Hedef sınıfı seç
                                      </option>


                                      {
                                        savedClasses
                                          .filter(
                                            cls =>
                                              String(
                                                cls.id
                                              ) !==
                                              String(
                                                viewingClass.id
                                              )
                                          )
                                          .sort(
                                            (a, b) =>
                                              String(
                                                a.name
                                              )
                                                .localeCompare(
                                                  String(
                                                    b.name
                                                  ),
                                                  'tr',
                                                  {
                                                    numeric: true
                                                  }
                                                )
                                          )
                                          .map(
                                            cls => (

                                              <option
                                                key={
                                                  cls.id
                                                }
                                                value={
                                                  cls.id
                                                }
                                              >
                                                {cls.name}
                                              </option>

                                            )
                                          )
                                      }

                                    </select>


                                    <button
                                      onClick={
                                        () =>
                                          handleMoveStudent(
                                            stu
                                          )
                                      }
                                      disabled={
                                        studentActionLoading ||
                                        !moveTargetClassId
                                      }
                                      className="px-4 py-2.5 bg-indigo-600 hover:bg-indigo-700 disabled:bg-indigo-300 text-white rounded-xl font-black text-xs transition"
                                    >

                                      {
                                        studentActionLoading
                                          ? "Taşınıyor..."
                                          : "Taşımayı Onayla"
                                      }

                                    </button>

                                  </div>

                                </td>

                              </tr>
                            )
                          }

                        </React.Fragment>

                      )
                    )

                ) : (

                  <tr>

                    <td
                      colSpan="3"
                      className="p-10 text-center text-slate-400 font-medium"
                    >
                      Bu sınıfta öğrenci bulunmuyor.
                    </td>

                  </tr>
                )
            }

          </tbody>

        </table>

      </div>


      {/* FOOTER */}
      <div className="p-4 bg-slate-50 border-t border-slate-200 shrink-0">

        <div className="flex flex-col sm:flex-row gap-3 justify-between">

          {
            academicYear ===
              activeAcademicYear && (

              <button
                onClick={() => {

                  setShowAddStudent(
                    prev =>
                      !prev
                  );

                  setMovingStudent(null);
                  setMoveTargetClassId('');

                }}
                className="px-5 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-black text-sm transition flex items-center justify-center gap-2"
              >

                <Plus className="h-4 w-4"/>

                Öğrenci Ekle

              </button>
            )
          }


          <button
            onClick={() => {

              setViewingClass(null);
              setShowAddStudent(false);
              setMovingStudent(null);
              setMoveTargetClassId('');

            }}
            className="bg-slate-200 hover:bg-slate-300 text-slate-700 px-6 py-2.5 rounded-xl font-bold text-sm transition"
          >
            Kapat
          </button>

        </div>

      </div>

    </div>

  </div>
)}
    </div>
  );
};

export default ClassManager;